module.exports = __webpack_public_path__ + "static/media/blackcat1.fb9868db.PNG";